export const SMALL_CARD_HEIGHT = 236;

export const LARGE_CARD_HEIGHT = 333;

export const SIZE_RATIO = {
  s: 0.39,
  m: 0.48,
  l: 0.51,
};
